{
  "replaceMessage": "Перетягніть файл для заміни"
}
